import React, { useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setOptions, reset } from "../../slices/optionsSlice.js";
import LayersBox from "./LayersBox/LayersBox.jsx";
import { Tooltip } from "react-tooltip";
import "./Settings.css";
import { zoomIn, zoomOut } from "../../slices/mapSlice.js";
import LayersIcon from "../../assets/images/svgs/LayersIcon.svg?react"
import ZoomPlusIcon from "../../assets/images/svgs/ZoomPlusIcon.svg?react"
import ZoomMinusIcon from "../../assets/images/svgs/ZoomMinusIcon.svg?react"
import SettingsBarIcon from "../../assets/images/svgs/SettingsBarIcon.svg?react"

const Settings = ({props}) => {

  const dispatch = useDispatch();
  
  const [showSettings, setShowSettings] = useState(false);

  const clickDetector = useRef(null);
  const settingsTooltip = useRef(null);

  const options = useSelector(state => state.options);
  const isSidebarOpen = useSelector(state => state.map.isSidebarOpen);

  const displaySettings = () => {
    settingsTooltip.current.close();
    if(!showSettings) {
      setShowSettings(true);
      dispatch(reset());
    } else {
      setShowSettings(false);
    }
  }

  const zoom = (type) => {
    if(type === 'zoomIn') {
      dispatch(setOptions("zoomIn"))
      dispatch(zoomIn());
    } else {
      dispatch(setOptions("zoomOut"))
      dispatch(zoomOut());
    }
  };

  return (
    <>
      {options.layers && 
        <LayersBox
          ref={clickDetector}
          props={props}
        />
      }
     
      <div className={isSidebarOpen ? "settingsOptions isSideBarOpen" : "settingsOptions"}>
        { showSettings && (
            <>
              <button
                data-tooltip-id="layers"
                data-tooltip-content="Layers"
                data-tooltip-place="left"
                data-tooltip-delay-hide={100}
                data-tooltip-delay-show={500}
                className={options.layers ? "settingsItem active" : "settingsItem"}
                onClick={() => dispatch(setOptions("layers"))}
              >
                <LayersIcon />
              </button>
              <Tooltip id="layers" />

              <button
                data-tooltip-id="zoomin"
                data-tooltip-content="Zoom In"
                data-tooltip-place="left"
                data-tooltip-delay-hide={100}
                data-tooltip-delay-show={500}
                className={options.zoomIn ? "settingsItem active" : "settingsItem"}
                onClick={() => zoom("zoomIn")}
              >
                <ZoomPlusIcon />
              </button>
              <Tooltip id="zoomin" />

              <button
                data-tooltip-id="zoomout"
                data-tooltip-content="Zoom Out"
                data-tooltip-place="left"
                data-tooltip-delay-hide={100}
                data-tooltip-delay-show={500}
                className={options.zoomOut ? "settingsItem active" : "settingsItem"}
                onClick={() => zoom("zoomOut")}
              >
                <ZoomMinusIcon />
              </button>
              <Tooltip id="zoomout" />
            </>
          )
        }

        <>
          <button
              data-tooltip-id="settings"
              data-tooltip-content="Settings"
              data-tooltip-place="left"
              data-tooltip-delay-show={500}
              className={showSettings && options.settingsActive ? "settingsItem active" : "settingsItem"}
              onClick={() => displaySettings()}
          >
            <SettingsBarIcon />
          </button>
          <Tooltip id="settings" ref={settingsTooltip} />
        </>

      </div>
    </>
  );
};

export default Settings;
